// extracted by mini-css-extract-plugin
module.exports = {"link":"_12Dtc","root":"_2Z-zX","label":"_27Vyn"};